import ScreenLoading from "@/components/ScreenLoading"
import RouterConfig from "@/router"
import usePay from "@/store/payment"
import useScreenLoading from "@/store/screenLoading"
import Decimal from "decimal.js"
import React from "react"

import requests from "@/requests/requests"

import { useAsyncEffect } from "./hooks"

const App: React.FC = () => {
    const { screenLoading, setScreenLoading } = useScreenLoading(s => ({
        screenLoading: s.screenLoading,
        setScreenLoading: s.setScreenLoading
    }))
    const { setChains, setGoods, setOrder, set404, setLoopOrder } = usePay(s => ({
        setChains: s.setChains,
        setGoods: s.setGoods,
        setOrder: s.setOrder,
        setLoopOrder: s.setLoopOrder,
        set404: s.set404
    }))

    useAsyncEffect(async () => {
        // const connection = new Connection_put("https://rpc.puttest.com")
        // const publicKey = new PublicKey_put("G4AY8GAdtdXoGzN9A2GbuaZn2t4t3dxfCBNmzHbPjJjU")
        // let account = await connection.getAccountInfo(new PublicKey_put("Qdpe3Cuy5DKXXMc59n3wS8Cwv437rswG1Zm3B9mBw9v"))
        // console.log(account)
        // let tokenAccount = await connection.getTokenAccountsByOwner(
        //     publicKey,
        //     {
        //         mint: new PublicKey_put("USDJASjwdezW9T1oCqDG2ui1PWrTt28QE1s7KBmaids")
        //     }
        // )
        // let a = await getTokenAccountFromOwner_put(connection, tokenAccount.value.map(item => item.pubkey))
        // console.log(tokenAccount, a, "account")
    }, [])

    React.useEffect(() => {
        console.log(Decimal.mul("0.1292619834593485", Math.pow(10, 6)).toNumber())
        console.log(Decimal.mul(2, 4).toNumber())
        console.log(Decimal.div(4, 2).toNumber())
        console.log(Decimal.add(4, 2).toNumber())
        // .toFixed(10, Decimal.ROUND_DOWN))
        document.addEventListener("touchstart", event => {
            if (event.touches.length > 1) {
                event.preventDefault()
            }
        }, {
            passive: false
        })
    }, [])

    React.useEffect(() => {
        window.location.pathname.includes("404") ?
            setScreenLoading(false) :
            requests.goods().then(goods => {
                setGoods(goods)
                if (goods.name) {
                    document.title = `${goods.name} - ReelPay`
                }
                if (goods.transaction) {
                    setOrder(goods.transaction)
                    setLoopOrder(goods.transaction)
                }
                setScreenLoading(false)
            }).catch(code => {
                if (code === 422) set404(true)
            })

        requests.currency().then(data => {
            setChains(data.filter(({ subset }) => !!subset?.length))
        }).catch(error => {
            console.log("request error", error)
        })
    }, [])

    return (
        <ScreenLoading spinning={screenLoading}>
            <RouterConfig></RouterConfig>
        </ScreenLoading>
    )
}

export default App
